import { data as source } from '../downloaded/cutscenes.mjs';

export const items = source.map((row) => row.paragraph);
